import styled from 'styled-components';
export var Inner = styled.div.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-1hr3pb6-0"
})(["display:inline;"]);
var COLORS = {
  equal: {
    background: 'accent1LL',
    text: 'accent1'
  },
  higher: {
    background: 'negativeLL',
    text: 'negative'
  },
  lower: {
    background: 'positiveLL',
    text: 'positive'
  }
};
export var Badge = styled.span.withConfig({
  displayName: "partials__Badge",
  componentId: "sc-1hr3pb6-1"
})(["display:inline-flex;align-items:center;height:20px;padding:4px 6px;border-radius:4px;margin-left:9px;background-color:", ";font-size:10px;font-weight:400;line-height:16px;white-space:nowrap;color:", ";", ""], function (_ref) {
  var theme = _ref.theme,
    type = _ref.type;
  return theme.colors[COLORS[type].background];
}, function (_ref2) {
  var theme = _ref2.theme,
    type = _ref2.type;
  return theme.colors[COLORS[type].text];
}, function (_ref3) {
  var onClick = _ref3.onClick;
  return onClick ? 'cursor: pointer;' : '';
});